if (document.querySelector(".js-rating") != null) {
    $(".js-rating").each(function (idx, el) {
        var input = $(this).find('input');
        var spans = $(this).find('.add-review__rating-star');
        var curRatimg = 0;

        function drawStarts(val) {
            $(spans).each(function (idx, el) {
                if (parseInt(val - 1) >= parseInt(idx)) {
                    $(el).find('use').attr('xlink:href','#icon-star-filled');
                } else {
                    $(el).find('use').attr('xlink:href','#icon-star-blank')
                }
            })
        }

        drawStarts(4);

        spans.hover(
            function () {
                drawStarts(parseInt($(this).index() + 1));
            },
            function () {
                drawStarts(curRatimg)
            }
        );

        spans.click(function () {
            curRatimg = $(this).index() + 1;
            drawStarts(parseInt(curRatimg));
            input.val(curRatimg);
        });
    });

    // $('.file_wrapper').click(function () {
    //     $('input[type=file]').click();
    // });

    // $('input[type=file]').change(function () {
    //     let name = $('input[type=file]')[0].files[0].name;
    //     $('.file_wrapper span').html(name)
    // });
}